const routes = [
  {
    path: "comentarios",
    component: () => import("@/views/cliente/comentarios/Comentarios.vue"),
    meta: {
      menu: "dashboard",
      title: "Comentarios",
    },
  },
];

export default routes;
